import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/security-settings',
    name: 'SecuritySettingsPage',
    component: () => import('@/modules/securitySettings/views/SecuritySettingsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/two-fa-confirm',
    name: 'TwoFAConfirmPage',
    component: () => import('@/modules/securitySettings/views/TwoFAConfirmPage.vue'),
    meta: {
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
  router.addRoute({
    path: '/two-fa-success',
    name: 'TwoFASuccessPage',
    component: () => import('@/modules/securitySettings/views/TwoFASuccessPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/user/verify/:token',
    name: 'EmailConfirmationPage',
    component: () => import('@/modules/securitySettings/views/EmailConfirmationPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
